import { cn } from '@/lib/cn';

export const HelpText = ({
  children,
  size = 'normal',
  className
}: {
  children: React.ReactNode;
  size?: 'normal' | 'sm';
  className?: string;
}) => {
  if (!children) {
    return null;
  }

  return (
    <span
      className={cn(
        'text-content-body mt-1 text-sm font-normal',
        {
          'text-sm': size === 'normal',
          'text-xs': size === 'sm'
        },
        className
      )}
    >
      {children}
    </span>
  );
};
